<div class="admin-sidenav-component">
  <img src="assets/images/logo.jpg" class="admin-sidenav-component__logo" alt="logo">
  <mat-divider></mat-divider>
  <mat-list>
    <mat-divider></mat-divider>
    <mat-list-item>
      <button mat-button color="primary" class="admin-sidenav-component__button" routerLink="/admin/dashboard"> Strona główna</button>
    </mat-list-item>
    <mat-list-item *ngIf="guard.hasPermission(USER_PERMISSIONS.USER)">
      <button mat-button color="primary" class="admin-sidenav-component__button" routerLink="/admin/account-manage"> Zarządzanie kontami</button>
    </mat-list-item>
    <mat-list-item *ngIf="guard.hasPermission(USER_PERMISSIONS.LOG)">
      <button mat-button color="primary" class="admin-sidenav-component__button" routerLink="/admin/logs"> Logi</button>
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item *ngIf="guard.hasPermission(USER_PERMISSIONS.PROPOSAL)">
      <button mat-button color="primary" class="admin-sidenav-component__button" routerLink="/admin/pool"> Dofinansowania</button>
    </mat-list-item>
    <mat-list-item *ngIf="guard.hasPermission(USER_PERMISSIONS.SCHOLARSHIP)">
      <button mat-button color="primary" class="admin-sidenav-component__button" routerLink="/admin/scholarship"> Stypendia</button>
    </mat-list-item>
    <mat-list-item *ngIf="guard.hasPermission(USER_PERMISSIONS.AWARD)">
      <button mat-button color="primary" class="admin-sidenav-component__button" routerLink="/admin/award"> Nagrody</button>
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item>
      <button mat-button color="warn" class="admin-sidenav-component__button" (click)="logout()"> Wyloguj</button>
    </mat-list-item>
  </mat-list>
</div>
